/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import api from '../../http/requests/api/index.js'


const localStorageKey = 'loggedIn'

const tokenExpiryKey = 'tokenExpiry'
export default {
  // JWT
  loginJWT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.login(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status) {

            this.tokenExpiry = new Date(Date.now() + (15 * 60 * 1000))
            localStorage.setItem(tokenExpiryKey, this.tokenExpiry)
            localStorage.setItem(localStorageKey, 'true')
            // Set accessToken
            localStorage.setItem('accessToken', response.data.token)

            // Update user details
            commit('SET_USER', response.data.data)

            // Set bearer token in axios
            commit('SET_BEARER', response.data.token)

            resolve(response)
          } else {
            reject({message: 'Wrong Email or Password'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getUserList ({ commit }, payload) {


    return new Promise((resolve, reject) => {
      api.getUserList(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_USERLIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getUsersRaw ({ commit }, payload) {
    const payload_ = {
      user_group: payload.user_group
    }
    return new Promise((resolve, reject) => {
      api.getUserList(payload_)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            let res_data =  response.data.data
            if (payload.user.user_group === 2 && payload.user_group === 3) {
              res_data = res_data.filter(data => {
                return JSON.parse(data.user_property['restaurants']).includes(parseInt(payload.user.id))
              })

            }
            commit('SET_USERS_RAW', res_data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setsizeoptions ({ commit }, payload) {
    commit('SET_SIZE_OPTIONS', payload)
  },
  setsizeoptionsitem ({ commit }, payload) {
    commit('SET_SIZE_OPTIONS_ITEM', payload)
  },
  setmodifieritems ({ commit }, payload) {
    commit('SET_MODIFIER_ITEMS', payload)
  },
  setmodifieritem ({ commit }, payload) {
    commit('SET_MODIFIER_ITEM', payload)
  },
  updateUserRegular ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveUser(payload)
        .then(response => {
          // Redirect User
          // Update data in localStorage
          //localStorage.setItem('accessToken', response.data.token)

          if (response.data.status !== false) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject(response.data)
          }

          commit('PASS', true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  cateringSendRestaurant ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.cateringSendRestaurant(payload)
        .then(response => {
          // Redirect User
          // Update data in localStorage
          //localStorage.setItem('accessToken', response.data.token)

          if (response.data.status !== false) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject(response.data)
          }

          commit('PASS', true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateUserSelf ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveUser(payload)
        .then(response => {
          // Redirect User
          // Update data in localStorage
          //localStorage.setItem('accessToken', response.data.token)

          if (response.data.status !== false) {
            commit('SET_USER', response.data.data)
            resolve(response)
          } else {
            reject(response.data)
          }

          commit('PASS', true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateUserJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveUser(payload)
        .then(response => {
          // Redirect User
          // Update data in localStorage
          //localStorage.setItem('accessToken', response.data.token)

          if (response.data.status !== false) {
            commit('SET_SELECTED_RESTAURANT', response.data.data)
            resolve(response)
          } else {
            reject(response.data)
          }

          commit('PASS', true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateUserLocation ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.saveUser(payload)
        .then(response => {

          if (response.data.status !== false) {
            resolve(response)
          } else {
            reject(response.data)
          }
          commit('PASS', true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  registerUser ({ commit }, payload) {

    const password = payload.password
    const confirmPassword = payload.confirmPassword


    return new Promise((resolve, reject) => {

      // Check confirm password


      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      api.saveUser(payload)
        .then(response => {
          if (response.data.status !== false) {
            resolve(response)
          } else {
            reject(response.data)
          }
          commit()
        })
        .catch(error => { reject(error) })
    })
  },
  duplicateUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {

      // Check confirm password
      api.duplicateUser(payload)
        .then(response => {
          if (response.data.status !== false) {
            resolve(response)
          } else {
            reject(response.data)
          }
          commit()
        })
        .catch(error => { reject(error) })
    })
  },
  uploadImage ({commit}, payload, onUploadProgress) {
    return new Promise((resolve, reject) => {
      api.uploadImage(payload, onUploadProgress)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit('SET_COMMIT_STATUS', response.data.status)
          } else {
            reject({message: 'error'})
          }
        })
    })
  },
  uploadLogo ({commit}, payload, onUploadProgress) {
    return new Promise((resolve, reject) => {
      api.uploadLogo(payload, onUploadProgress)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject({message: 'error'})
          }
        })
    })
  },
  uploadImageProfile ({commit}, payload, onUploadProgress) {
    return new Promise((resolve, reject) => {
      api.uploadImageProfile(payload, onUploadProgress)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject({message: 'error'})
          }
        })
    })
  },
  uploadContent ({commit}, payload, onUploadProgress) {
    return new Promise((resolve, reject) => {
      api.addContent(payload, onUploadProgress)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject({message: response.data.message})
          }
        })
    })
  },
  getSectionList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSectionList(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_SECTION_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  arrangeSection ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.arrangeSection(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getSizeList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSizeList(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_SIZE_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getProductList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getProductList(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_PRODUCT_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getProductListAll ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getProductListAll()
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_PRODUCT_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  searchProductList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getProductList(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getProduct ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getProduct(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getRestaurant ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getRestaurant(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getModifierList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getModifierList(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_MODIFIER_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setPropertyListForUser ({ commit }, user_property) {
    commit('SET_PROPERTY_LIST', user_property)
  },
  setPropertyListItemForUser ({ commit }, payload) {
    commit('SET_PROPERTY_ITEM', payload)

  },
  setPickupHour ({ commit }, payload) {
    commit('SET_PICKUP_HOUR', payload)
  },
  setDeliveryHour ({ commit }, payload) {
    commit('SET_DELIVERY_HOUR', payload)
  },
  setRestaurantStatus ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.setRestaurantStatus(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getDeliveryHours ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getWeeklyHours(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_DELIVERY_HOURS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getPickupHours ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getWeeklyHours(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_PICKUP_HOURS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  saveWeeklyHours ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.saveWeeklyHours(payload)
        .then(response => {

          // If there's user data in response
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getPropertyList ({ commit }, payload) {


    return new Promise((resolve, reject) => {
      api.getPropertyList(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_PROPERTIES', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getPropertyTypes ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getPropertyTypes()
        .then(response => {

          // If there's user data in response
          if (response.status) {

            commit('SET_PROPERTY_TYPES', response.data.data)
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addProduct ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.addProduct(payload)
        .then(response => {

          // If there's user data in response
          if (response.status) {
            commit('SET_USER_SAVE', response.data.data)
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addSection ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.addSection(payload)
        .then(response => {

          // If there's user data in response
          api.getSectionList(payload)
            .then(response => {

              // If there's user data in response
              if (response.status) {

                commit('SET_SECTION_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }

            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addSize ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.addSize(payload)
        .then(response => {

          // If there's user data in response
          api.getSizeList(payload.restaurantId)
            .then(response => {

              // If there's user data in response
              if (response.status) {

                commit('SET_SIZE_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addProperty ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.addProperty(payload)
        .then(response => {

          // If there's user data in response
          api.getPropertyTypes()
            .then(response => {

              // If there's user data in response
              if (response.status) {

                commit('SET_PROPERTY_TYPES', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addModifier ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.addModifier(payload)
        .then(response => {
          // If there's user data in response
          api.getModifierList(payload.restaurantId)
            .then(response => {

              if (response.status) {

                commit('SET_MODIFIER_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeProperty ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeProperty(payload)
        .then(response => {
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeProduct ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeProduct(payload)
        .then(response => {
          api.getProductList(payload)
            .then(response => {
              if (response.status) {
                commit('SET_PRODUCT_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeProductImage ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeProductImage(payload)
        .then(response => {
          api.getProductList(payload)
            .then(response => {
              if (response.status) {
                commit('SET_PRODUCT_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeModifier ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeModifier(payload)
        .then(response => {

          // If there's user data in response
          api.getModifierList(payload)
            .then(response => {

              if (response.status) {

                commit('SET_MODIFIER_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeSize ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeSize(payload)
        .then(response => {
          // If there's user data in response
          api.getSizeList(payload)
            .then(response => {
              // If there's user data in response
              if (response.status) {
                commit('SET_SIZE_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeSection ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeSection(payload)
        .then(response => {
          api.getSectionList(payload)
            .then(response => {
              // If there's user data in response
              if (response.status) {
                commit('SET_SECTION_LIST', response.data.data)
                resolve(response)
              } else {
                reject({message: 'Error'})
              }
  
            }).catch(() => { })
          if (response.status) {
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeUser({ user_id: payload.user_id })
        .then(response => {
          if (response.status) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  checkTokenValid ({ commit }) {

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        api.checkToken()
          .then(response => {
            // If there's user data in response
            if (response.data.status === true) {
              commit('SET_TOKEN_VALID', true)
              resolve(response)
            } else {
              commit('SET_TOKEN_VALID', false)
              reject({message: response.data.status})
            }

          })
          .catch(error => { reject(error) })
      }, 1000)
    })
  },
  getContents ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getContentList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_CONTENTLIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  campaignList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getCampaignList(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeContents ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeContent(payload)
        .then(response => {
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.status.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getOrders ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getOrderList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_ORDERS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCateringOrderList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getCateringOrderList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_CATERING_ORDERS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCateringOrderOfferList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getCateringOrderOfferList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_CATERING_ORDER_OFFERS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getOrder(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response.data.data)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCateringOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getCateringOrder(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response.data.data)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getOrderStatuses ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getOrderStatusList()
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_ORDER_STATUSES', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setOrderStatus ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.setOrderStatus(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_ORDER_STATUS_CHANGED', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setCateringOrderStatus ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.setCateringOrderStatus(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_CATERING_ORDER_STATUS_CHANGED', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCouponList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getCouponList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_COUPONS', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setCoupon ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.setCoupon(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeCoupon ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeCoupon(payload)
        .then(response => {
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.status.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setBoundary ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.setBoundry(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setBoundaryZipcode ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.setBoundryZipcode(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getBoundaryList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getBoundaryList(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_BOUNDARIES', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getBoundary ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getBoundary(payload)
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeZipcodeBoundary ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeZipcodeBoundary(payload)
        .then(response => {
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.status.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  removeBoundary ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeBoundary(payload)
        .then(response => {
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.status.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  forgotPassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.forgotPassword(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('', '')

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  resetPassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.resetPassword(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  verifyMail ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.verifyMail(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  changePassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.changePassword(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  changeUserPassword ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.changeUserPassword(payload)
        .then(response => {

          // If there's user data in response
          if (response.data.status === true) {
            commit('PASS', true)

            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },

  getStripeAccount ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getStripeAccount(payload)
        .then(response => {
          commit('PASS', true)
          resolve(response)

        })
        .catch(error => { reject(error) })
    })
  },
  getStripeTransfers ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getStripeTransfers(payload)
        .then(response => {
          commit('PASS', true)
          resolve(response)

        })
        .catch(error => { reject(error) })
    })
  },
  getMonthlyInvoices ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getMonthlyInvoices(payload)
        .then(response => {
          commit('PASS', true)
          resolve(response)

        })
        .catch(error => { reject(error) })
    })
  },
  getWeeklyInvoices ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getWeeklyInvoices(payload)
        .then(response => {
          commit('PASS', true)
          resolve(response)

        })
        .catch(error => { reject(error) })
    })
  },
  addBankAccount ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.addBankAccount(payload)
        .then(response => {
          commit('PASS', true)
          resolve(response)

        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  createStripeAccount ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.createStripeAccount(payload)
        .then(response => {
          commit('PASS', true)
          resolve(response)

        })
        .catch(error => { reject(error) })
    })
  },

  getEvent ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.getEvent(payload)
        .then(response => {
          // If there's user data in response
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addEvent ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.addEvent(payload)
        .then(response => {
          // If there's user data in response
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'Error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  eventList ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.eventList(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  restaurantSales ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.restaurantSales(payload)
        .then(response => {
          if (response.data.status === true) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.data.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addRestaurantSale ({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.addRestaurantSale(payload)
        .then(response => {
          // If there's user data in response
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'Error'})
          }
          
        })
        .catch(error => { reject(error) })
    })
  },
  removeEvent ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.removeEvent(payload)
        .then(response => {
          if (response.status) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: response.status.message})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getProfile ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getProfile()
        .then(response => {
          // If there's user data in response
          if (response.data.status === true) {
            commit('SET_PROFILE', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }
          
        })
        .catch(error => { reject(error) })
    })
  }
}
